"use client";

import { useEffect } from "react";

export default function ParallaxContainer(props) {
  useEffect(() => {
    // Import jarallax lazily on the client only — its module touches `document`
    // at load, so a top-level import would crash server-side rendering (this
    // component is now imported statically instead of via dynamic ssr:false).
    let cancelled = false;
    import("jarallax").then(({ jarallax }) => {
      if (!cancelled) {
        jarallax(document.querySelectorAll(".parallax-5"), { speed: 0.5 });
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return (
    <div
      //   ref={parallax.ref}
      {...props}
    >
      {props.children}
    </div>
  );
}
